export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  date: string;
  image: string;
  author: string;
}

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'how-often-chimney-cleaned',
    title: 'How Often Should You Have Your Chimney Cleaned in Jacksonville?',
    excerpt: 'Jacksonville homeowners who use their fireplaces regularly should schedule chimney cleanings at least once a year. Learn why annual chimney maintenance is critical for safety and performance in Florida\'s climate.',
    category: 'Chimney Cleaning',
    readTime: '5 min read',
    date: 'February 28, 2026',
    image: 'https://public.readdy.ai/ai/img_res/7f23897dc250d34ff8878a3b267ee88b.jpg',
    author: 'BBM Services Team',
  },
  {
    id: '2',
    slug: 'signs-air-ducts-need-cleaning',
    title: '7 Signs Your Air Ducts Need Cleaning Right Now',
    excerpt: 'Wondering if your home\'s air quality is suffering from dirty ductwork? These seven warning signs indicate your Jacksonville home\'s HVAC system is overdue for a professional air duct cleaning.',
    category: 'Air Duct Cleaning',
    readTime: '6 min read',
    date: 'February 14, 2026',
    image: 'https://readdy.ai/api/search-image?query=closeup%20of%20dusty%20air%20vent%20cover%20with%20visible%20dust%20particles%20in%20air%2C%20home%20interior%20with%20visible%20air%20quality%20issue%2C%20particles%20visible%20in%20light%20beam%2C%20HVAC%20air%20quality%20concern%2C%20residential%20home%20interior&width=800&height=500&seq=blog002&orientation=landscape',
    author: 'BBM Services Team',
  },
  {
    id: '3',
    slug: 'dryer-vent-fire-prevention',
    title: 'Dryer Vent Cleaning: The $99 Service That Could Save Your Home',
    excerpt: 'Nearly 2,900 homes catch fire each year due to clogged dryer vents. This simple, affordable service is one of the most overlooked home safety measures — find out why every Jacksonville homeowner needs it.',
    category: 'Dryer Vent Cleaning',
    readTime: '4 min read',
    date: 'January 30, 2026',
    image: 'https://readdy.ai/api/search-image?query=dryer%20lint%20fire%20hazard%20safety%20infographic%20style%2C%20lint%20buildup%20in%20vent%20duct%20pipe%2C%20laundry%20room%20safety%2C%20fire%20prevention%20at%20home%2C%20residential%20laundry%20room%20with%20dryer%2C%20safety%20awareness%20visual&width=800&height=500&seq=blog003&orientation=landscape',
    author: 'BBM Services Team',
  },
  {
    id: '4',
    slug: 'air-quality-jacksonville-homes',
    title: 'Why Indoor Air Quality Matters More Than You Think in Jacksonville',
    excerpt: 'Jacksonville\'s humid climate makes Florida homes especially vulnerable to mold, dust mites, and allergen buildup in HVAC systems. Here\'s how professional duct cleaning improves your family\'s health and comfort.',
    category: 'Air Duct Cleaning',
    readTime: '7 min read',
    date: 'January 15, 2026',
    image: 'https://readdy.ai/api/search-image?query=family%20breathing%20clean%20fresh%20air%20in%20modern%20home%20interior%2C%20happy%20family%20in%20clean%20bright%20living%20room%2C%20air%20quality%20and%20home%20health%20concept%2C%20comfortable%20Jacksonville%20Florida%20style%20home%2C%20warm%20natural%20lighting%2C%20healthy%20home%20environment&width=800&height=500&seq=blog004&orientation=landscape',
    author: 'BBM Services Team',
  },
  {
    id: '5',
    slug: 'chimney-inspection-levels-explained',
    title: 'Level I vs Level II Chimney Inspections: What\'s the Difference?',
    excerpt: 'Not all chimney inspections are the same. Understanding the difference between Level I and Level II inspections helps you choose the right service for your Jacksonville home and fireplace.',
    category: 'Chimney Cleaning',
    readTime: '5 min read',
    date: 'January 5, 2026',
    image: 'https://readdy.ai/api/search-image?query=chimney%20inspector%20with%20flashlight%20and%20camera%20equipment%20inspecting%20brick%20chimney%20interior%2C%20professional%20chimney%20inspection%20service%2C%20detailed%20technical%20inspection%20of%20fireplace%20flue%2C%20residential%20home%2C%20professional%20uniform&width=800&height=500&seq=blog005&orientation=landscape',
    author: 'BBM Services Team',
  },
  {
    id: '6',
    slug: 'fall-home-maintenance-checklist',
    title: 'Jacksonville Fall Home Maintenance Checklist: Don\'t Skip These Services',
    excerpt: 'Before fireplace season arrives, Jacksonville homeowners should check off these essential maintenance tasks including chimney cleaning, dryer vent cleaning, and HVAC duct inspection to stay safe all season.',
    category: 'Home Safety',
    readTime: '8 min read',
    date: 'December 10, 2025',
    image: 'https://readdy.ai/api/search-image?query=cozy%20Jacksonville%20Florida%20home%20interior%20with%20fireplace%2C%20fall%20season%20home%20maintenance%20concept%2C%20warm%20autumn%20indoor%20setting%2C%20living%20room%20with%20fireplace%20ready%20for%20season%2C%20comfortable%20home%2C%20seasonal%20home%20care&width=800&height=500&seq=blog006&orientation=landscape',
    author: 'BBM Services Team',
  },
];
